/* this file added by Bearer Web Developer  */
import React from "react";
import styles from './earliestTime.module.scss';
import timeSensitiveManagement from "./timeSensitiveManagement";
import { useThemeMode } from "../../../states/contexts/theme";
import { TimeSensitiveEnum } from "../../../states/scheduleOrderstate";
interface Props {
    earliest_pickup_time: number
}
const EarliestTime: React.FC<Props> = ({ earliest_pickup_time }) => {
    const textTime: TimeSensitiveEnum = timeSensitiveManagement(earliest_pickup_time);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.earliest_time} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            {
                textTime === TimeSensitiveEnum.PastDue ?
                    <section className={styles.past_due}>
                        {
                            theme === "dark" ? <img src="/priority-high-light.svg" alt="" width={20} height={20} /> :
                                <img src="/priority-high.svg" alt="" width={20} height={20} />
                        }
                        {textTime}
                    </section>
                    : textTime === TimeSensitiveEnum.DueSoon ?
                        <section className={styles.due_soon}>
                            {
                                theme === "dark" ? <img src="/event-available-light-green.svg" alt="" width={20} height={20} /> :
                                    <img src="/event-available-green.svg" alt="" width={20} height={20} />
                            }
                            {textTime}
                        </section>
                        : (textTime === TimeSensitiveEnum.DueToday || textTime === TimeSensitiveEnum.DueTodayPastTime) ?
                            <section className={styles.due_today}>
                                {
                                    theme === "dark" ? <img src="/event-available-light-yellow.svg" alt="" width={20} height={20} /> :
                                        <img src="/event-available-yellow.svg" alt="" width={20} height={20} />
                                }
                                {TimeSensitiveEnum.DueToday}
                            </section> :
                            <section className={styles.time_sensitive}>
                                {
                                    theme === "dark" ? <img src="/event-available-light-blue.svg" alt="" width={20} height={20} /> :
                                        <img src="/event-available-blue.svg" alt="" width={20} height={20} />
                                }
                                {textTime}
                            </section>
            }
        </div>
    )
}
export default EarliestTime;
